import React, { useState } from "react";
import { Icon } from "../icons";
import { avatarColor, fmtDate, initials } from "../lib/format";
import { useMcOps } from "../lib/McOpsContext";

/** Job search box + results dropdown — mirrors renderJobSearch() from the prototype. */
export const JobSearch = ({ style }) => {
  const { state, openJob, recordSearch } = useMcOps();
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  const q = query.trim().toLowerCase();
  const list = q
    ? state.jobs.filter(
        (j) =>
          j.clientName.toLowerCase().includes(q) ||
          j.zohoId.toLowerCase().includes(q) ||
          (j.phone || "").toLowerCase().includes(q),
      )
    : (state.searchHistory || [])
        .map((id) => state.jobs.find((j) => j.id === id))
        .filter(Boolean);
  const heading = q ? "Results" : "Recent searches";

  const pick = (id) => {
    recordSearch(id);
    openJob(id);
    setQuery("");
    setOpen(false);
  };

  return (
    <div
      className="job-search-wrap"
      style={style}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false);
      }}
    >
      <div className="job-search-box">
        <Icon name="search" />
        <input
          type="text"
          placeholder="Search jobs by name, Zoho #, phone..."
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
        />
      </div>
      <div className={`job-search-results${open ? " open" : ""}`}>
        {list.length ? (
          <>
            <div className="search-heading">{heading}</div>
            {list.slice(0, 8).map((j) => (
              <div
                className="search-result"
                key={j.id}
                tabIndex={-1}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => pick(j.id)}
              >
                <div
                  className="jc-avatar"
                  style={{
                    background: avatarColor(j.moveType),
                    width: 22,
                    height: 22,
                    fontSize: 9,
                  }}
                >
                  {initials(j.clientName)}
                </div>
                <div>
                  <div className="sr-name">{j.clientName}</div>
                  <div className="sr-meta">
                    {j.zohoId} · {fmtDate(j.moveDate)}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="search-empty">
            {q
              ? "No jobs found."
              : "No recent searches yet — start typing to search."}
          </div>
        )}
      </div>
    </div>
  );
};

/** Page title row with the centred search box, used on every board page. */
export const BoardTitleRow = ({ title }) => (
  <div
    className="page-title-row"
    style={{
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
    }}
  >
    <div>
      <h2 className="page-title">{title}</h2>
    </div>
    <JobSearch style={{ justifySelf: "center" }} />
    <div />
  </div>
);
